export default __webpack_public_path__ + "static/media/43.5f340d56.jpg";